export default __webpack_public_path__ + "static/media/brand-poseidon.be8016f0.jpg";